import React from 'react'
import './DescriptionBox.css'

const DescriptionBox = () => {
  return (
    <div className='descriptionbox'>
        <div className="descriptionbox-navigator">
            <div className="descriptionbox-nav-box">
                Desctiption
            </div>
            <div className="descriptionbox-nav-box fade">
                Reviews (122)
            </div>
            </div>
            <div className="descriptionbox-description">
                <p>Our e-commerce website offers a seamless shopping experience,
                  bringing a world of products right to your fingertips. With an intuitive
                  interface and user-friendly navigation, finding your desired items has never
                  been easier. We pride ourselves on our vast selection of high-quality products, 
                  ranging from the latest tech gadgets to fashionable apparel and home essentials.</p>
        </div>
    </div>
  )
}

export default DescriptionBox